import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const CAMPAIGN_STATS_REQUEST = 'CAMPAIGN_STATS_REQUEST';
export const CAMPAIGN_STATS_SUCCESS = 'CAMPAIGN_STATS_SUCCESS';
export const CAMPAIGN_STATS_FAILURE = 'CAMPAIGN_STATS_FAILURE';

export const CAMPAIGN_STATS_DETAILS_REQUEST = 'CAMPAIGN_STATS_DETAILS_REQUEST';
export const CAMPAIGN_STATS_DETAILS_SUCCESS = 'CAMPAIGN_STATS_DETAILS_SUCCESS';
export const CAMPAIGN_STATS_DETAILS_FAILURE = 'CAMPAIGN_STATS_DETAILS_FAILURE';

export const CAMPAIGN_STATS_EXPORT_REQUEST = 'CAMPAIGN_STATS_EXPORT_REQUEST';
export const CAMPAIGN_STATS_EXPORT_SUCCESS = 'CAMPAIGN_STATS_EXPORT_SUCCESS';
export const CAMPAIGN_STATS_EXPORT_FAILURE = 'CAMPAIGN_STATS_EXPORT_FAILURE';

export const loadCampaignStats = (options) => ({
	[CALL_API]: {
		types: [CAMPAIGN_STATS_REQUEST, CAMPAIGN_STATS_SUCCESS, CAMPAIGN_STATS_FAILURE],
		endpoint: `api/reports/campaignStats`,
		request: options,
		schema: Schemas.CAMPAIGN_STATS_ARRAY
	}
});

export const loadCampaignStatsDetails = (options) => ({
	[CALL_API]: {
		types: [CAMPAIGN_STATS_DETAILS_REQUEST, CAMPAIGN_STATS_DETAILS_SUCCESS, CAMPAIGN_STATS_DETAILS_FAILURE],
		endpoint: `api/reports/campaignStatsDetails`,
		request: options,
		schema: Schemas.CAMPAIGN_STATS_DETAILS_ARRAY
	}
});

export const exportCampaignStats = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [CAMPAIGN_STATS_EXPORT_REQUEST, CAMPAIGN_STATS_EXPORT_SUCCESS, CAMPAIGN_STATS_EXPORT_FAILURE],
			endpoint: `api/reports/campaignStats/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `CampaignStats-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}